export default __webpack_public_path__ + "static/media/alift.16e9436f.jpg";